import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import router from "./router";


export default /*#__PURE__*/_defineComponent({
  __name: 'stub-router-view',
  setup(__props) {

const { currentRoute } = router;

// The purpose of this control is to ensure routing is initialized on views
// which do not actually use it.
// This is to support the ?team=blahdeblah functionality.

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, { name: "unused" }))
}
}

})